var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrepaidCardIcon = function SvgPrepaidCardIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 21,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 21,
    rx: 3.5,
    stroke: "#AEAEAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0H14V3.02746C13.2656 3.10865 12.5844 3.36658 12 3.75777C11.4156 3.36658 10.7344 3.10865 10 3.02746V0ZM5.02746 8H0V12H7.17144L7.5939 11.5775C6.20504 10.9272 5.20302 9.58814 5.02746 8ZM10 14.8283V22H14V14.5461L12.0603 12.768L10 14.8283ZM17.1421 12H32V8H18.9725C18.8046 9.51923 17.8804 10.8105 16.5847 11.489L17.1421 12Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.97 8.61584L18.6758 14.7628L17.3244 16.2371L12.0302 11.3841L7.20718 16.2071L5.79297 14.7929L11.97 8.61584Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.05051C11.3647 4.40223 10.4793 4 9.5 4C7.567 4 6 5.567 6 7.5C6 9.433 7.567 11 9.5 11C10.4793 11 11.3647 10.5978 12 9.94949C12.6353 10.5978 13.5207 11 14.5 11C16.433 11 18 9.433 18 7.5C18 5.567 16.433 4 14.5 4C13.5207 4 12.6353 4.40223 12 5.05051ZM8 7.5C8 6.67157 8.67157 6 9.5 6C10.3284 6 11 6.67157 11 7.5V9H9.5C8.67157 9 8 8.32843 8 7.5ZM14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5V9H14.5Z",
    fill: "#AEAEAE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrepaidCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "prepaid-card-icon.a76e9b0af4bd4bf224ada921d5931feb.svg";